module.exports = __webpack_public_path__ + "img/whatsapp-icon-mobile-en.59a4671.png";